'use strict';
angular.module('appMarketplace')
    .directive('about', ['UrlService', 'NotificationService', 'HelpService', 'CommonService', '$compile', '$templateCache',
                        '$http',
                        function (UrlService, NotificationService, HelpService, CommonService, $compile, $templateCache,
                                  $http) {
        return {
            restrict: 'A',
            scope: {
                versionInfo: '@'
            },
            link: function (scope, element, attrs) {
                var window;

                element.on('click', function clickHandler() {
                    if (window && window.element.length) {
                        return;
                    }

                    $http.get(UrlService.createAbsoluteUrl('/js/main/directives/templates/about-template.html?ver=31d283f53c6f5b2f6f2c499914ce24b7'), {cache: $templateCache})
                        .then(function successCallback(response) {
                            HelpService.getVersionInfo(function successCallback(data) {
                                scope.versionInfo = data;
                                var templateElement = angular.element(response.data);
                                var windowElement = $compile(templateElement.filter(".about-template").html())(scope);
                                var position = {
                                    top: element.offset().top,
                                    left: element.offset().left
                                };
                                window = windowElement.kendoWindow({
                                    title: "About",
                                    width: 350,
                                    maxHeight: 250,
                                    visible: false,
                                    resizable: false,
                                    deactivate: function () {
                                        this.destroy();
                                    }
                                }).data("kendoWindow").openInPosition(position);
                            }, function errorCallback(responseError) {
                                NotificationService.showErrorMessage(responseError);
                            });
                        }, NotificationService.showValidationErrors);
                });
            }
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/directives/about-directive.js
// module id = 189
// module chunks = 17